import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { getLabelMessage } from '@gef-ui/localization/messages';

import InfoCircleTooltip from 'components/atoms/GefMui/InfoCircleTooltip';

import List from './List';

export const InformationSettings = () => {
	const settingsHeader = (
		<Stack
			spacing={1}
			direction="row"
			sx={{
				alignItems: 'center',
			}}
		>
			<Typography variant="h5" color="text.primary">
				{getLabelMessage('settings:informationSettings')}
			</Typography>
			<InfoCircleTooltip text={getLabelMessage('settings:informationSettingsTooltip')} />
		</Stack>
	);

	return (
		<Paper sx={{ p: 3, borderRadius: 2 }}>
			<Stack>
				{settingsHeader}
				<List />
			</Stack>
		</Paper>
	);
};

export default InformationSettings;
